import { createFileRoute } from "@tanstack/react-router"
import DataValidation from "~/pages/data-validation"

export const Route = createFileRoute("/_auth/data-validation/")({
  component: RouteComponent,
})

function RouteComponent() {
  return <DataValidation />
}
